/**
 * Background Assets
 *
 * Background images and patterns for various UI contexts.
 */

import type { AssetPath } from '../types';

/**
 * Base path for backgrounds
 */
const BACKGROUNDS_BASE = '/assets/images/backgrounds';

/**
 * Gradient backgrounds (as CSS or image)
 */
export const GRADIENT_BACKGROUNDS = {
  hero: {
    path: `${BACKGROUNDS_BASE}/gradient-hero.svg`,
    alt: '',
    width: 1920,
    height: 1080,
  },
  auth: {
    path: `${BACKGROUNDS_BASE}/gradient-auth.svg`,
    alt: '',
    width: 1920,
    height: 1080,
  },
  dashboard: {
    path: `${BACKGROUNDS_BASE}/gradient-dashboard.svg`,
    alt: '',
    width: 1920,
    height: 1080,
  },
} as const;

/**
 * Pattern backgrounds
 */
export const PATTERN_BACKGROUNDS = {
  dots: {
    path: `${BACKGROUNDS_BASE}/pattern-dots.svg`,
    alt: '',
    width: 100,
    height: 100,
  },
  grid: {
    path: `${BACKGROUNDS_BASE}/pattern-grid.svg`,
    alt: '',
    width: 100,
    height: 100,
  },
  waves: {
    path: `${BACKGROUNDS_BASE}/pattern-waves.svg`,
    alt: '',
    width: 200,
    height: 100,
  },
} as const;

/**
 * All backgrounds
 */
export const BACKGROUNDS = {
  gradient: GRADIENT_BACKGROUNDS,
  pattern: PATTERN_BACKGROUNDS,
} as const;

/**
 * Get background asset
 */
export function getBackground(
  category: keyof typeof BACKGROUNDS,
  name: string
): AssetPath | undefined {
  const categoryBackgrounds = BACKGROUNDS[category] as Record<string, AssetPath>;
  return categoryBackgrounds[name];
}
